<div class="producer-picker">
    <section class="panel" aria-labelledby="available-title">
        <div class="panel-header">
            <h2 id="available-title">Disponíveis</h2>
        </div>

        <mat-form-field appearance="outline" class="search-field">
            <mat-label>Buscar por nome ou código</mat-label>
            <input matInput [formControl]="producerSearchCtrl" autocomplete="off" />
            <mat-icon matSuffix>search</mat-icon>
        </mat-form-field>

        @if (filteredProducers$ | async; as picker) {
            @if (picker.status === 'idle') {
                <p class="state-message">Digite pelo menos {{ minSearchLength }} letras para buscar produtores.</p>
            } @else if (picker.status === 'loading') {
                <div class="state-message" role="status">
                    <mat-spinner diameter="24"></mat-spinner>
                    <span>Buscando produtores…</span>
                </div>
            } @else if (picker.status === 'error') {
                <p class="state-message state-error" role="alert">Não foi possível buscar produtores. Tente novamente.</p>
            } @else if (picker.total === 0) {
                <p class="state-message">Nenhum produtor disponível para esta busca.</p>
            } @else {
                <ul class="candidate-list">
                    @for (producer of picker.items; track trackById($index, producer)) {
                        <li class="candidate">
                            <span class="code">{{ producer.code }}</span>
                            <span class="name">{{ producer.name }}</span>
                            <button
                                type="button"
                                mat-stroked-button
                                class="action-btn"
                                [attr.aria-label]="'Adicionar ' + producer.name"
                                (click)="producerSelected.emit(producer)"
                            >
                                <mat-icon>add</mat-icon>
                                Adicionar
                            </button>
                        </li>
                    }
                </ul>
                @if (picker.total > picker.items.length) {
                    <p class="hint">Mostrando {{ picker.items.length }} de {{ picker.total }}. Refine a busca para ver mais.</p>
                }
            }
        }
    </section>

    <section class="panel" aria-labelledby="follow-title">
        <div class="panel-header">
            <h2 id="follow-title">Acompanhamento</h2>
            <span class="badge">{{ selectedProducers.length }}</span>
        </div>

        @if (selectedProducers.length) {
            <ul class="linked-list">
                @for (producer of selectedProducers; track trackById($index, producer)) {
                    <li class="linked">
                        <span class="code">{{ producer.code }}</span>
                        <span class="name">{{ producer.name }}</span>
                        <button
                            type="button"
                            mat-stroked-button
                            color="warn"
                            class="action-btn"
                            [attr.aria-label]="'Remover ' + producer.name"
                            (click)="producerRemoved.emit(producer)"
                        >
                            <mat-icon>delete_outline</mat-icon>
                            Remover
                        </button>
                    </li>
                }
            </ul>
        } @else {
            <div class="state-message empty">
                <mat-icon class="empty-icon">groups</mat-icon>
                <p>Nenhum produtor em acompanhamento. Adicione produtores à esquerda.</p>
            </div>
        }
    </section>
</div>
